import type { IconData } from '@stacksjs/iconify-core'

export const golf: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M378.841 342.034C339.372 327.825 287.223 320 232 320a538 538 0 0 0-80 5.793V211.157l152-56v-38.131l-152-71.2V16h-32v400h32v-57.834A501 501 0 0 1 232 352c51.621 0 99.921 7.153 136 20.143C403.43 384.9 416 399.43 416 408s-12.57 23.1-48 35.857C331.921 456.847 283.621 464 232 464s-99.921-7.153-136-20.143C60.57 431.1 48 416.57 48 408c0-7.89 10.669-20.832 40-32.788v-34.176q-1.429.493-2.841 1C28 362.612 16 389.265 16 408s12 45.388 69.159 65.966C124.628 488.175 176.777 496 232 496s107.372-7.825 146.841-22.034C436 453.388 448 426.735 448 408s-12-45.388-69.159-65.966M152 81.163l114.586 53.675L152 177.054Z\"/><circle cx=\"432\" cy=\"280\" r=\"32\" fill=\"currentColor\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default golf
